import { TakeOverSensorExcessFn, IncidentAssignment } from "../../../../../rest/Dashboard/interfaces";
import { FlagActions } from "../../../../flux/Flag/FlagActions";
import { ErrorActions } from "../../../../flux/Error/ErrorActions";
import { AssignPersonActions } from "../AssignPersonActions";
import { ListActions } from "../../../../flux/Grid/ListActions";
import { appNavigator } from "../../../../routes";
import { Command1 } from "../../../../../Command";

export class TakeOverSensorExcessCommand implements Command1<IncidentAssignment>
{
    private readonly listActions = new ListActions();
    private readonly inProgress = new FlagActions();
    private readonly errorActions = new ErrorActions();
    private readonly assignActions = new AssignPersonActions();
    
    constructor(private takeOverSensorExcess: TakeOverSensorExcessFn, private listDispatchToken: string, private inProgressDispatchToken: string, private errorDispatchToken: string)
    {
    }
    
    execute = (assignment: IncidentAssignment) => {
        this.inProgress.set(this.inProgressDispatchToken);
        this.takeOverSensorExcess(assignment)
            .then(res => {
                const se = res.SensorsExcess;
                se.date = new Date(se.DateTime);
                this.listActions.upsertItems([se], this.listDispatchToken);
                appNavigator.goToAlarm();
                this.assignActions.reject();
            })
            .catch(err => this.errorActions.setError(err, this.errorDispatchToken))
            .then(() => this.inProgress.reset(this.inProgressDispatchToken)); //finally
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Home/commands/TakeOverSensorExcessCommand.ts